import { CardPaymentConfiguration } from '@journeyapps-platform/types-charging-station';
import React from 'react';
import CreditCard from 'react-credit-cards';
import 'react-credit-cards/lib/styles-compiled.css';
import { styled } from '../../../../../theme';

export interface CreditCardWidgetProps {
  card: CardPaymentConfiguration;
  selected?: boolean;
  width: number;
  className?: any;
}

export const CreditCardWidget: React.FC<CreditCardWidgetProps> = (props) => {
  return (
    <S.Card className={props.className} selected={!!props.selected} width={props.width}>
      <CreditCard
        preview={true}
        issuer={props.card.issuer_display}
        cvc={'***'}
        expiry={`${props.card.exp_month}/${props.card.exp_year}`}
        number={`**** **** **** ${props.card.last_4}`}
        name={props.card.name}
      />
    </S.Card>
  );
};

namespace S {
  // this is the size of the card in scss
  const WIDTH = 290;
  const HEIGHT = 182.873;

  export const Card = styled.div<{ width: number; selected: boolean }>`
    transform: scale(${(p) => p.width / WIDTH});
    width: ${(p) => p.width}px;
    height: ${(p) => (p.width / WIDTH) * HEIGHT}px;
    transform-origin: top left;

    .rccs__card--front {
      color: white !important;
    }

    .rccs__card__background {
      background: ${(p) => (p.selected ? p.theme.plans.upgradeOption.selectedBackground : 'transparent')};
    }
  `;
}
